export const sort_items = {
  data() {
    return {
      sort: {prop: 'name', order: 'ascending'},
    }
  },
  computed: {
    sortedItems() {
      if (this.items.length < 1 || !this.sort) { return []; }
      if (!this.sort.prop) { return this.items }
      let prop = this.sort.prop;
      let items = Object.assign([], this.items)
      if (this.sort.order === 'descending') {
        items = this.util.quickSort(items, prop, false);
      } else {
        items = this.util.quickSort(items, prop);
      }
      return items;
    },
  },
  methods: {
    handleSortChange(sort) {
      if (sort.order) {
        this.sort = sort;
      } else {
        this.sort = {};
      }
    }
  },
}